import { CalendarContextMenu } from "@/features/calendar/components/CalendarContextMenu";
import { useDroppable } from "@dnd-kit/core";
import { LightMode } from "@repo/skapa";
import { useState } from "react";

import { ClickableWeekBlock } from "./components";

interface DropProps {
  id: string;
  date: Date;
  emailId?: string;
  selectedTeam?: number;
  isWorking: boolean;
  allDaySlot: boolean;
  noBorderRight?: boolean;
  noBorderBottom?: boolean;
  alignItems?: string;
  height: number;
  width: number;
  onClick?: () => void;
}

export const DroppableHourBlock = ({
  id,
  date,
  emailId,
  selectedTeam,
  allDaySlot,
  isWorking,
  noBorderRight,
  noBorderBottom,
  alignItems,
  height,
  width,
  onClick,
}: DropProps) => {
  const [menuRef, setMenuRef] = useState<HTMLDivElement | null>(null);

  const { setNodeRef, active } = useDroppable({
    id,
    data: {
      date,
      allDaySlot,
    },
  });

  return (
    <CalendarContextMenu
      menuRef={menuRef}
      date={date}
      emailId={emailId}
      selectedTeam={selectedTeam}
      onClick={onClick}
    >
      <ClickableWeekBlock
        key={id}
        ref={(r) => {
          setNodeRef(r);
          setMenuRef(r);
        }}
        color={
          isWorking
            ? LightMode.colourStaticWhite
            : LightMode.colourStaticLightGrey
        }
        noBorderRight={noBorderRight}
        noBorderBottom={noBorderBottom}
        alignItems={alignItems}
        height={height}
        width={width}
        onClick={active ? undefined : onClick}
      />
    </CalendarContextMenu>
  );
};
